import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { Trash2 } from 'lucide-react';
export const ConfirmDeleteModal = ({ isOpen, itemName, onConfirm, onCancel }) => {
    useEffect(() => {
        if (!isOpen)
            return;
        const handleKeyDown = (e) => {
            if (e.key === 'Escape')
                onCancel();
            if (e.key === 'Enter')
                onConfirm();
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [isOpen, onCancel]);
    if (!isOpen)
        return null;
    return (_jsxs("div", { className: "fixed inset-0 flex items-center justify-center z-50", children: [_jsx("div", { className: "ls-modal-backdrop", onClick: (e) => {
                    if (e.target === e.currentTarget)
                        onCancel();
                } }), _jsxs("div", { className: "ls-modal-card ls-modal-card-animate relative max-w-xs w-full mx-4 p-4", style: { backgroundColor: 'var(--charcoal)' }, onClick: (e) => e.stopPropagation(), children: [_jsxs("p", { className: "text-sm mb-3", style: { color: 'var(--sand)' }, children: ["Delete ", _jsx("span", { className: "font-semibold", children: itemName }), "?"] }), _jsxs("div", { className: "flex justify-end gap-2", children: [_jsx("button", { onClick: onCancel, className: "px-3 py-1.5 text-xs rounded transition-colors", style: {
                                    backgroundColor: 'var(--pewter)',
                                    color: 'var(--sand)'
                                }, children: "Cancel" }), _jsxs("button", { onClick: onConfirm, className: "px-3 py-1.5 text-xs rounded transition-colors flex items-center gap-1", style: {
                                    backgroundColor: '#dc2626',
                                    color: 'white'
                                }, children: [_jsx(Trash2, { size: 12 }), "Delete"] })] })] })] }));
};
